package dairy.mynotes

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.firestore
import dairy.mynotes.firebase.FirebaseService
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.events.Event

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    // Global JS error handler
    window.onerror = { _, _, _, _, _ -> false }

    window.addEventListener("unhandledrejection", { _: Event -> })

    try {
        val app = Firebase.initialize(
            options = FirebaseOptions(
                applicationId = "1:444048311453:web:f491bab3f6ee2baeccc074",
                apiKey = "AIzaSyA7j6HMbHuP5C9RvJ8jhvzw58UkwMqv_AU",
                authDomain = "mynotes-d6f0e.firebaseapp.com",
                projectId = "mynotes-d6f0e",
                storageBucket = "mynotes-d6f0e.firebasestorage.app",
                gcmSenderId = "444048311453"
            )
        )
        val auth = Firebase.auth(app)
        val firestore = Firebase.firestore(app)
        FirebaseService.initialize(auth, firestore)
    } catch (_: Exception) {
        // Firebase init failed — app will show error state
    }

    val body = document.body ?: return

    ComposeViewport(body) {
        App()
    }
}
